export default
    {
        name :'Elias.',
        headerTagline: [
                        'Elias Miño',
                        
                        'Peluqueria profesional',
                        
                        'Argentina'
    ],
        contactEmail:'',
        abouttext: "No intento hacer lo que hace todo el mundo, porque todo el mundo hace lo que hacen los demás.",
        imageportate: 'Eliasdos.png',
        aboutImage:'Eliascuatro.jpg',
       ShowAboutImage:true,
       projects:[
           {
            id: 1,
             imageSrc:"imagendiez.jpg",
            },
            {
                id: 2,
                imageSrc: "imagendos.jpeg",
            },
            { 
                id: 3,
                imageSrc: "imagenonce.jpg",
            },
            {
                id: 4,
                imageSrc: "imagencuatro.jpeg",
           },
           {
            id: 5,
            imageSrc: "imagencinco.jpeg",
       },
       {
        id: 6,
        imageSrc: "imagenseis.jpeg",
   },
   {
    id: 7,
    imageSrc: "imagensiete.jpeg",
},
{
    id: 8,
    imageSrc: "imagendoce.jpg",
},


/*
{
    id: 8,//DO NOT CHANGE THIS
    title: 'Project Four',
    service: 'Branding',
    imageSrc: "imagendoce.jpg",
    url: 'http://chetanverma.com/'
},*/

        ],
        social: [
            {
                name: 'Facebook',
                url: 'https://www.facebook.com/eloo.mino'
            },
            {
                name: 'Instagram',
                url: 'https://www.instagram.com/eliasm.99/'
            }
        ]
    }